import { render, staticRenderFns } from "./TextFieldEditor.vue?vue&type=template&id=2b52cae6&"
import script from "./TextFieldEditor.vue?vue&type=script&lang=ts&"
export * from "./TextFieldEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports